import Fusion360Img from '../images/Fusion360.jpeg'
import tableauicon from '../images/tableauicon.png'
import cbatesicon from '../images/cbatesicon.jpeg'
import nhsicon from '../images/nhs.jpeg'
import MLPredictionProject from '../images/MLPredictionProject.png'
import tweeter from '../images/tweeter.png'
import obesity from '../images/Obesity.png'
import hateCrimes from '../images/HateCrimes.png'
import ihs from '../images/ihs.png'
import olympicsML from '../images/OlympicsML.png'
import salaryML from '../images/SalaryML.png'
import streamlit from '../images/streamlit.png'
import shirt from '../images/3d-shirt.png'
import fastapi from '../images/fastapi.png'
import ytscript from '../images/YTScript.png'
import langchain from '../images/langchain.png'
import openai from '../images/openai.jpeg'
import uwischool from '../images/UWischool.jpeg'
import redditicon from '../images/redditicon.png'
import AISnake from '../images/AISnakeGame.png'
import Chatbot from '../images/Chatbot.png'
import UW from '../images/UW.jpeg'
import closebot from '../images/closebot.png'
import lambda from '../images/Lambda.png'
import huggingface from '../images/hf-logo.png'
import gpt2 from '../images/gpt2.jpeg'
import datathon from '../images/datathon.png'
import fina from '../images/fina.png'
import finaProject from '../images/finaProject.png'
import finaLinkPreview from '../images/finaLinkPreview.png'
import vitaLogo from '../images/vitaLogo.png'
import vectorDB from '../images/vectorDB.png'
import ecommerce from '../images/ecommerce.png'
import form from '../images/form.png'


export const Bio = {
    name: "Collin Shen",
    roles: [
      "AI Engineer",
      "Fullstack Engineer",
      "Data Scientist",
    ],
    description:
      "Hi, I'm Collin, an AI Engineer and builder focused on shipping production-ready AI systems. I've designed multi-agent architectures with LangChain and LangGraph, built and deployed full-stack AI features at Fina, and co-founded an AI startup that blends social media with intelligent agents. My experience spans prompt engineering, LLM infrastructure, vector databases, and scalable microservices. I thrive in fast-paced environments where I can work close to users, iterate quickly, and turn ambiguous problems into impactful AI products. I’m currently exploring AI Engineering and Forward Deployed Engineering roles where I can contribute end-to-end technical execution.",
    github: "https://github.com/collinshen123",
    resume:
      "https://docs.google.com/document/d/12TS8kAHh3cuzrX_yW4odsFd3dHukmL6y64LixXkITFM/edit?usp=sharing",
    linkedin: "https://www.linkedin.com/in/collin-shen123/",
    twitter: "https://twitter.com/collin70556799",
    insta: "https://www.instagram.com/collin_shen/",
    facebook: "https://www.facebook.com/profile.php?id=100086144701351",
  };
  
  export const skills = [
    {
      title: "ML/AI",
      skills: [
        
        {
          name: "langchain",
          image: langchain,
        },
        {
          name: "Pytorch",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg",
        },
        {
          name: "OpenAI API",
          image: openai,
            
        },
        {
          name: "Hugging Face",
          image: huggingface,
        },
        {
          name: "Pydantic",
          image:
            "https://avatars.githubusercontent.com/u/110818415?s=200&v=4",
        },
        {
          name: "Embedding Models",
          image:
            "",
        },
        {
          name: "Semantic Search Algorithms",
          image: "",
        },
        {
          name: "Reddit API",
          image: redditicon,
            
        },
        {
          name: "AWS Lambda",
          image:
            lambda,
        },
        
      ],
    },
    {
      title: "Backend",
      skills: [
        
        
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Java",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
        },
        {
          name: "R",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/r/r-original.svg",
        },
        {
          name: "FastAPI",
          image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/fastapi/fastapi-original.svg"        
        },
        
        {
          name: "SQL",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azuresqldatabase/azuresqldatabase-original.svg",
        },
        {
          name: "TypeScript",
          image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Typescript.svg/128px-Typescript.svg.png"        
        },
        {
          name: "Pandas",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg",
        },
        {
          name: "Numpy",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg",
        },
        {
          name: "Firebase",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
        },
        
        {
          name: "Node.js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
        },
        {
          name: "Nest.js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nestjs/nestjs-original.svg",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        
        
        
      ],
    },
    {
      title: "Frontend",
      skills: [
        {
          name: "React",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Streamlit",
          image:
          streamlit,
        },
        {
          name: "Tableau",
          image:
            tableauicon,
        },  
        {
          name: "Next.js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        
        {
          name: "Figma",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
        },
        {
          name: "Blender",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/blender/blender-original.svg",
        },
        {
          name: "Fusion 360",
          image:
            Fusion360Img,
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        
        {
          name: "Docker",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
        },
        
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Jupyter Notebook",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jupyter/jupyter-original-wordmark.svg",
        },
        {
          name: "PyCharm",
          image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pycharm/pycharm-original.svg",
        },
        
        {
          name: "MS Office",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAB/CAMAAADxY+0hAAAAflBMVEXrPAD////rNQDrOQD//Pvvb1bpJAD5zMLqMAD85N/xhm/qKgD60sn85+H++PX97+r3wLP73dX0o5H2tqnweWHuY0r3vK/0nov0p5nsSBvyk3zva07xf2n4xbntTynrPQ/tWDvsUDTuZET2r5/zl4TtVDDrRCTpBgDvbEfxh3d43bv2AAACyklEQVRoge2a666qMBCFsYVaaGm5KKigIHg5vv8LnoJmxwsIauvOTmb9l2+cNTBNuiwLBAKBQCDQ3xWmiKJfgyO2XPFFhhjC36cjgvO1mCjJwNuQ79aAGHZiOfmRCCOnYPQ7JWBKyyi0J7ey/cDbUvPToEz3pmLSKcnTSg2kuTYgRrNEdsMvcuNZQYy0ATM2r/2n8IsVPJ0jorcNmLLt7sH0/hLcJN/oK6Axff2874/y53pcUH3P4jF9v5ejga/6vo/egSsPPuZjRNQXdrTpmvnK9Fnwqum6+M1HbtTLZoKPKSnS8CP4B3xECm86BiB5VHHN/GazDXxhGwl3nVYHRMmTQl/nq+NMx2Z7ZCer+ZK2G18rH+PT0Mtmh7FXMvKz4/Tyn8+7nKYZJbd7RS/f7XuUcINVWXScLr7AF2Gcl0vafawwzLfDOi+pOtj1rVLD/Pw4cK41zPfowE+AD3zgAx/4wAc+8IEPfOADH/jABz7wgQ984AMf+MB/mW+H1dATDPJFkrHBBxjjc4+SET83w/frDRty3hhf8PwwOr+hne8vqldyPHrvP/2pcxzjuiE+Xv5brZw9IoRR1HvlZY5v4aLccSnDOPWc7RIxNpgl0stvb6Czurn+tqXLkyivtgWiFPWWoZtvtRmnS7CtkXB5oMqwWOPJYxkG+OcSvLubcBkGC8/Z3M+GGX4b/9h3JDCEH64jzykvs4GN8dsmoJuM39WDRduNrDzgozl+W4Ll8Z6s3bkbyZPIwOd8JUo2uzeTMFr4bQKrrHuTCeb5VuND8UYSSmjjn2Noqyej8AjnC6fQhr+UUC7GJbJkctrQ4cPT6yUwVnW/ktd/PC2p5vDlldQo5H3x1zZ1eTCdwW2ScV1JUMnTeUG/kkFut+TNKDRxUxOO9woRNLtsSTHdlcyc4/0lsOWJu/XMYr+VwVc+FCbj1iAQCAQCgbTpP3CDOmIarFJwAAAAAElFTkSuQmCC",
        }, 
        
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: fina,
      role: "Fullstack AI Engineer",
      company: "Fina",
      date: "Aug 2025 - Present",
      desc: "Designed and optimized prompts using LangChain, OpenAI, and Redis to tune Fina's AI chatbot with REST api integrations, participating in agile sprint planning and CI/CD pipelines for automated deployment to production. Developed the AI Native mobile app MVP for iOS and Android using React Native and WebView with Docker containerization, enabling users to access Fina's web platform seamlessly on mobile devices.",
      skills: [
          "LangChain",
          "LLM",
          "CI/CD",
          "React Native",
          "Redis",
      ],

    },
    {
      id: 0,
      img: vitaLogo,
      role: "Co-Founder & Fullstack AI Engineer",
      company: "Stealth Startup",
      date: "Nov 2024 - Present",
      desc: "Architected a multi-agent AI system using LangChain, LangGraph, RAG, and persistent memory that transforms social media content into actionable health and wellness plans with real-time personalization. Built and deployed key infrastructure with FastAPI and AWS Lambda, including OAuth social integrations, content recommendation pipelines, and AI-driven video summarization with location/calendar-based triggers. Defined product roadmap, co-authored the business plan, and helped drive early investor interest for scaling into the $4B+ digital wellness market. Operated independently in an async, fast-paced environment, owning full-stack delivery from prototype to deployment.",
      skills: [
          "RAG",
          "LangChain",
          "Multimodal Video Summarization",
          "AI Agent Design",
          "Entrepreneurial Product Development",
      ],
      link: "https://vitaai-phi.vercel.app/login",
      linkName: "Personalized AI Lifestyle Planner using RAG, LangChain, and Multimodal Summarization.", 
      linkImg: vitaLogo,

    },
    {
      id: 0,
      img: fina, // Image for the entire entry
      role: "AI Software Development Intern",
      company: "Fina",
      date: "Jun 2024 - Sep 2024",
      desc: "Developed AI-powered features for personal finance management, focusing on budgeting tools. Specialized in AI prompt engineering to fine-tune responses for personalized user experiences. Utilized Nest.JS, HTTP requests, OpenAI API, and Fina's proprietary database to integrate intelligent budgeting suggestions, enhancing the platform's appeal to attract more users.",
      skills: [
          "OpenAI API",
          "Prompt Engineering",
          "REST API",
          "Next.js",
          "SQL",
      ],
      link: "https://medium.com/@collinshen123/leveraging-ai-to-simplify-personal-finance-my-summer-internship-at-fina-aa7cf4927a8e",
      linkName: "Leveraging AI to Simplify Personal Finance: My Summer Internship at Fina", 
      linkImg: finaLinkPreview,
      linkDescription: "link.medium.com", 

    },
    {
      id: 0,
      img: closebot,
      role: "Machine Learning Intern",
      company: "CloseBot AI",
      date: "Feb 2024 - Jul 2024",
      desc: "AI conversational technology development, specializing in NLP and LLMs, in collaboration with industry leaders. Engineered chatbot optimization using Python and AWS Lambda, reducing OpenAI call dependency by 40% and slashing operational costs by $15,000 annually.",
      skills: [
        "Python",
        "Prompt Engineering",
        "OpenAI API",
      ],
      doc: "",
    },
    {
      id: 0,
      img: UW,
      role: "Undergraduate Research Assistant",
      company: "University of Washington",
      date: "Jan 2024 - Present",
      desc: "Working with a team of researchers to develop a new programming language aimed to improve the accessibility of programming for users with language and vision disibilities.",
      skills: [
        "Wordplaypen"
      ],
      doc: "",
    },
    {
      id: 0,
      img: uwischool,
      role: "Info 103 Teaching Assistant",
      company: "University of Washington Information School",
      date: "Aug 2023 - Jan 2024",
      desc: "Held office hours, graded assignments, and taught a 1 hour section every week with 35 students.",
      skills: [
        "Python",
        "Jupyter Notebook",
        "Reddit API",
      ],
      doc: "",
    },
    {
      id: 0,
      img: cbatesicon,
      role: "Content Wrting and Data Analyst Intern",
      company: "Cbates (Communities Building Attitudes To Encourage Success)",
      date: "June 2022 - Sep 2022",
      desc: "Produced impactful content to support social services for marginalized communities. Developed insightful data visualizations to complement analytical findings.",
      skills: [
        "Tableau",
        "MS Word",
        "MS Excel",
        "Power Point",
      ],
      doc: "",
    },
    {
      id: 0,
      img: "",
      role: "Business owner",
      company: "Elderly Personal Services · Freelance",
      date: "Apr 2021 - Present",
      desc: "Established a venture aimed at providing personalized in-home support services to elderly clients.",
      skills: [
        "MacOS",
        "MS Office 365",
      ],
      doc: "",
    },
    
    
  ];
  
  export const education = [
    {
      id: 0,
      img: UW,
      school: "Univeristy of Washington, Seattle",
      date: "9/2022 - 6/2025",
      grade: "3.8",
      desc: "I have completed a Bachelor's degree in Informatics with a focus in Data Science at the University of Washington, Seattle. I have taken courses in Data Structures & Algorithms, Search and Recommendation Systems, Object-Oriented Programming, Machine Learning, Database Management Systems, among others.",
      degree: "Informatics - Data Science",
    }
    
   
  ];
  
  export const projects = [
    {
      id: 14,
      title: "E-commerce AI Agent",
      date: "Oct 2025",
      description:
        "Architected a multimodal AI shopping assistant using a single LangGraph agent that intelligently decides between LangChain tool calls for text-based semantic search and CLIP-powered image-to-product matching, leveraging Sentence Transformers and ChromaDB vector database for intelligent recommendations. Built full-stack application with FastAPI backend and Next.js/TypeScript frontend, implementing hybrid search with vector embeddings and metadata filtering (price, brand, rating) for real-time product recommendations across 100+ products",
      image:
      ecommerce,
      tags: [
        "Langgraph",
        "Sentence Transformer",
        "ChromaDB",
        "FastAPI",
        "Next.js",
        "Docker",


      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/ecommerce-ai-agent",
      webapp: "",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    }, 
    {
      id: 14,
      title: "Form Management Chatbot",
      date: "Oct 2025",
      description:
        "Engineered an AI-powered chatbot using OpenAI function calling and FastAPI to collect structured user data, implementing SQLAlchemy database models and REST API endpoints for CRUD operations with status validation. Developed full-stack interface with Next.js and React for real-time form display and filtering, designing a scalable revision history system to track field-level changes across database entities.",
      image:
      form,
      tags: [
        "Langgraph",
        "SQLAlchemy",
        "FastAPI",
        "Next.js",
        "React",
        "CRUD",
        "Pydantic",


      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Form-Management-Chatbot",
      webapp: "",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    }, 
    {
      id: 14,
      title: "Vector DB From Scratch",
      date: "Jun 2025",
      description:
        "Built a custom vector database from scratch with embedding generation and semantic search using a HuggingFace model called sentence transformers and FastAPI",
      image:
      vectorDB,
      tags: [
        "Embedding Models",
        "Semantic Search Algorithms",
        "Pydantic Validation ",
        "FastAPI",
        "Docker Containerization",


      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/vector-db-api",
      webapp: "",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },    
    {
      id: 14,
      title: "Personal Finance AI",
      date: "Jun 2024 - Sep 2024",
      description:
        "Leveraging AI to Simplify Personal Finance. Developed a personalized AI budgeting tool that analyzes historical spending data synced from your bank.",
      image:
      finaProject,
      tags: [
        "OpenAI API",
        "Prompt Engineering",
        "HTTP Requests",
        "Nest.js",
        "TypeScript",
        "SQL",


      ],
      category: "fullstack", 
      github: "https://github.com/finalabs",
      webapp: "https://medium.com/@collinshen123/leveraging-ai-to-simplify-personal-finance-my-summer-internship-at-fina-aa7cf4927a8e",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },    
    {
      id: 13,
      title: "GPT-2 From Scratch",
      date: "Apr 2024 - Jun 2024",
      description:
        "An implementation of a transformer model from scratch. Diving deep into the internals of a transformer using Mechanistic Interpretability.",
      image:
        gpt2,
      tags: [
        "Python",
        "Jupyter Notebook",
        "Tokenization",
        "Positional Embedding",
        "MLP",
        "Attention",
        "Unembedding",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Mechanistic-Interpretability",
      webapp: "https://github.com/collinshen123/Mechanistic-Interpretability",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },
    {
      id: 12,
      title: "Border Crossing ARIMA Model",
      date: "May 2024",
      description:
        "This project analyzes US border crossing data and uses time series forecasting (ARIMA model) to predict future border crossing volumes.",
      image:
        datathon,
      tags: [
        "Python",
        "Jupyter Notebook",
        "ARIMA",
        "Pandas",
        "Matplotlib",
        "Scikit-learn",
        "NumPy",
        "Pickle",
        "Streamlit"
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Dubstech-Datathon-24",
      webapp: "https://collinshen123-dubstech-datathon-2-ml-modelprediction-app-nyliap.streamlit.app/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },
    {
      id: 11,
      title: "Sneaker Storefront Chatbot",
      date: "Dec 2023 - Jan 2024",
      description:
        "A Python chatbot project utilizing PyTorch, NLTK, and TKinter to create an interactive AI-driven experience for a sneaker storefront.",
      image:
        Chatbot,
      tags: [
        "Python",
        "Pytorch",
        "NLTK",
        "Feed Forward Neural Network",
        "Tokenization",
        "Stemming",
        "Bag of Words",
        "TKinter"
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Sneaker_Storefront_ChatBot",
      webapp: "https://github.com/collinshen123/Sneaker_Storefront_ChatBot",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },
    {
      id: 1,
      title: "AI Snake Game",
      date: "Dec 2023 - Jan 2024",
      description:
        "A python reinforcement learning project that uses Pytorch and Pygame to train an AI to play the classic snake game.",
      image:
        AISnake,
      tags: [
        "Python",
        "Pytorch",
        "Pygame",
        "Rienforcement Learning",
        "Deep Q Learning",
        "ML",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/AI-Snake-Game",
      webapp: "https://github.com/collinshen123/AI-Snake-Game",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },
    {
      id: 2,
      title: "Youtube Video Script Generator",
      date: "Sep 2023 - Nov 2023",
      description:
        "A streamlit application that leverages Lanchain and the OpenAI API to generate Youtube scripts based off LLMs and Wikipedia research.",
      image:
        ytscript,
      tags: [
        "Python",
        "LangChain",
        "OpenAI API",
        "Streamlit",
        "Wikipedia",
        "LLM",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/LangChain-YT-script-generator",
      webapp: "https://langchain-yt-script-generator-collin.streamlit.app/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        
      ],
    },
    {
      id: 3,
      title: "Salaries ML Prediction Project",
      date: "Sep 2023 - Oct 2023",
      description:
        "Developed a machine learning Decision Tree Regressor web app to predict Software Engineering salaries based off of given country, education level, and years of experiance. Model was trained with data from Stack Overflow Developer Survey 2023",
      image:
      salaryML,
      tags: [
        "Python",
        "Jupiter Notebook", 
        "Streamlit",
        "Decision Tree Regressor",
        "Pandas",
        "Matplotlib",
        "Scikit-learn",
        "NumPy",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Salary-ML-App",
      webapp: "https://salary-prediction-collinshen.streamlit.app/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 4,
      title: "Tweeter",
      date: "Aug 2023 - Sep 2023",
      description:
        "Developed a full-stack web application using Next.js that emulates the functionalities and visual aesthetics of Twitter.",
      image:
        tweeter,
      tags: ["Next.Js", "Node.js", "React", "HTML", "CSS", "JavaScript", "TypeScript"],
      category: "fullstack",
      github: "https://github.com/collinshen123/chirp",
      webapp: "https://tweeter-collin.vercel.app/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 5,
      title: "ML Prediction Project",
      date: "Oct 2022 - Nov 2022",
      description:
        "Developed a machine learning prediction model to classify fruits in a project focused on accurate fruit identification.",
      image:
      MLPredictionProject,
      tags: [
        "Python",
        "Jupiter Notebook", 
        "Tensorflow",
        "KNN",
        "Keras",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/ML-Prediction-Project",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 6,
      title: "FastAPI ML App",
      date: "Sep 2023 - Oct 2023",
      description:
        "A Fast API app where you can upload an image and input a question and it will generate an answer based off of the image and question. The model was trained with the VQA dataset.",
      image:
      fastapi,
      tags: [
        "Python",
        "Docker",
        "Jupiter Notebook", 
        "FastAPI",
        "Pillow",
        
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/FastAPI-ML-App",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 7,
      title: "3D-shirt",
      date: "July 2023 - Sep 2023",
      description:
        "Developed a full-stack web application using Three.js that allows you to design your own shirt on a interactive 3D model. Create your own designs with your own or AI generated images.",
      image:
        shirt,
      tags: ["Three.Js", "Node.js", "React", "HTML", "CSS", "JavaScript", "Dall-e", "OpenAI API", "Valtio"],
      category: "fullstack",
      github: "https://github.com/collinshen123/3D-shirt",
      webapp: "https://3d-shirt-collin.vercel.app/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 8,
      title: "Olympics ML Prediction Project",
      date: "Aug 2023 - Sep 2023",
      description:
        "Developed an ML project leveraging historical Olympic data to forecast a country's future medal count through a Linear Regression model. This project employed libraries such as pandas, matplotlib, seaborn, and scikit-learn to analyze and make predictions.",
      image:
      olympicsML,
      tags: [
        "Python",
        "Jupiter Notebook", 
        "Pandas",
        "Matplotlib",
        "Scikit-learn",
        "Seaborn",
        "Linear Regression",
      ],
      category: "machine learning",
      github: "https://github.com/collinshen123/Olympics-ML",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
      ],
    },
    {
      id: 9,
      title: "Obesity Study",
      date: "Nov 2022 - Dec 2022",
      description:
        "Conducted a comprehensive data analysis project using R to explore obesity trends in the United States.",
      image:
        obesity,
      tags: [
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
        "NodeMailer",
      ],
      category: "data science",
      github: "https://github.com/info201b-au2022/project-collinshen123",
      webapp: "https://cshen123.shinyapps.io/docs/",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        {
          name: "Jaime Li",
          img: "https://avatars.githubusercontent.com/u/105523676?v=4"
        },
        {
          name: "Erzhan Umar",
          img: "https://avatars.githubusercontent.com/u/115045228?v=4"
        },
        {
          name: "Kailynn nguyen",
          img: "https://avatars.githubusercontent.com/u/115045182?v=4"
        },
      ],
    },
    {
      id: 10,
      title: "Hate Crime Analysis",
      date: "May 2023 - June 2023",
      description:
        "Conducted a hate crime data analysis project using Python and pandas to uncover insights and patterns of Hate crime within the United States.",
      image:
        hateCrimes,
      tags: ["Python", "Pandas", "Numpy", "MatPlotLib", "PyCharm", "Plotly"],
      category: "data science",
      github: "https://github.com/GConscious/ProjectHateCrimes",
      member: [
        {
          name: "Collin Shen",
          img: "https://avatars.githubusercontent.com/u/58667267?v=4",
          linkedin: "https://www.linkedin.com/in/collin-shen-50806a228/",
          github: "https://github.com/collinshen123",
        },
        {
          name: "Amrith Gandham",
          img: "https://avatars.githubusercontent.com/u/61984726?v=4"
        },
        {
          name: "Mykyta Lepikash",
          img: "https://avatars.githubusercontent.com/u/115119452?v=4"
        },
        
      ],
    },
    
  ];
  
  